export default __webpack_public_path__ + "assets/797f262656e1e9989f9897d5f1d8dee6.jpg";